export const STORE_BASE_URL = process.env.REACT_APP_STORE_BASE_URL;
export const WHOLESALE_BASE_URL = process.env.REACT_APP_WHOLESALE_BASE_URL;
export const PARTNER_BASE_URL = process.env.REACT_APP_PARTNER_BASE_URL;
export const MARKETPLACE_BASE_URL = process.env.REACT_APP_MARKETPLACE_BASE_URL;
export const BACKOFFICE_BASE_URL = process.env.REACT_APP_BACKOFFICE_BASE_URL;
